// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_22-1";
export var movingGradient = "_22-4";
export var movingGradientBlock = "_22-2";
export var skeleton = "_22-0";
export var skeletonText = "_22-3";